import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLightningBoltOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLightningBoltOff"><Path d="M13.8584 16.334L9.5166 22.0234L10.1777 14.75H4.7334L7.99609 10.4717L13.8584 16.334Z" fill="currentColor"/><Path d="M20.0293 18.9697L18.9688 20.0303L3.96875 5.03027L5.0293 3.96973L20.0293 18.9697Z" fill="currentColor"/><Path d="M13.8203 9.25H19.2646L16.001 13.5273L10.1387 7.66504L14.4814 1.97656L13.8203 9.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLightningBoltOff;
